import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './dropdownItem.html' with { type: 'html' };

export default {
	name: 'CDropdownItem',
	components: {
		cSvg
	},
	props: {
		isClosed: {
			type: Boolean,
			default: false
		},
		isFocused: {
			type: Boolean,
			default: false
		},
		isSelected: {
			type: Boolean,
			default: false
		},
		paymentOption: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		isCreditCard() {
			return this.paymentOption.type === 'creditCard';
		},
		isPayPalBilling() {
			return this.paymentOption.type === 'payPalBilling';
		},
		isBancontact() {
			return this.paymentOption.type === 'bancontact';
		},
		getIcon() {
			if (this.isPayPalBilling) {
				return '#payment-paypal-text';
			}
			if (this.isBancontact) {
				return '#payment-bancontact-icon';
			}
			const paymentCardBrand = this.paymentOption.card.brand.toLowerCase();
			return ['amex', 'american-express', 'americanexpress', 'dinersclub', 'discover', 'jcb', 'unionpay', 'mastercard', 'master-card', 'visa'].includes(paymentCardBrand) ? `#payment-${paymentCardBrand}` : '#payment-card';
		},
		getTitle() {
			if (this.isPayPalBilling) {
				return this.t('paymentMethod_payPalBilling');
			}
			if (this.isBancontact) {
				return this.t('paymentMethod_bancontact');
			}
			return this.paymentOption.card.brand;
		},
		getShortYear() {
			return this.isCreditCard || this.isBancontact ? this.paymentOption.card.expirationYear.toString().slice(-2) : '';
		}
	},
	template
};
